import React, { forwardRef } from "react";
import * as styles from "./styles.css";

interface GridAreaProps extends React.HTMLAttributes<HTMLDivElement> {
  areaTemplate: number[][];
  gap: string;
  children: React.ReactElement[];
}

export const GridArea = forwardRef(
  (
    { areaTemplate, gap = "8px", children, ...props }: GridAreaProps,
    ref: React.Ref<HTMLDivElement>,
  ) => {
    const colCount = areaTemplate[0].reduce((acc, cur) => {
      return acc + Math.abs(cur);
    }, 0);
    let start = 0;

    return (
      <div
        ref={ref}
        className={styles.gridAreaContainer}
        style={{
          [styles.gapVar]: gap,
          [styles.colCountVar]: colCount,
        }}
        {...props}
      >
        {areaTemplate.map((row) => {
          const elementsCount = row.length;
          const positiveCount = row.filter((el) => el > 0).length;

          const elementsToReturn = children
            .slice(start, start + elementsCount)
            .map((child, idx) => {
              if (row[idx] < 0) {
                return (
                  <div style={{ gridColumn: `span ${Math.abs(row[idx])}` }} />
                );
              }
              return React.cloneElement(child, {
                style: {
                  ...child.props.style,
                  gridColumn: `span ${row[idx]}`,
                },
              });
            });

          start += positiveCount;
          return elementsToReturn;
        })}
        {children.slice(start + 1).map((child) => {
          return child;
        })}
      </div>
    );
  },
);

GridArea.displayName = "GridArea";
